// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.ReturnOrderRequest */
/* istanbul ignore next */
@GandalfModel
export class ReturnOrderRequest extends GandalfModelBase {

	@GandalfLabel('Comments')
	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfLabel('Order')
	@GandalfValidator({ notNull: { message: 'Order is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	orderId!: number;

	@GandalfLabel('Return Reason')
	@GandalfValidator({ notNull: { message: 'Return Reason is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	returnReasonId!: number;

}
